export const loadBaslandiJob = () => {
  try {
    const serializedState = localStorage.getItem('baslandiFis');
    if (serializedState === null || serializedState.FisNo) {
      return undefined;
    }
    return [JSON.parse(serializedState)];
  } catch (err) {
    return [];
  }
};
export const loadUrunControlDetail = () => {
  try {
    const serializedState = localStorage.getItem('UrunControlDetail');
    if (serializedState === null || serializedState === undefined) {
      return [];
    } else {
      return [JSON.parse(serializedState)];
    }
  } catch (err) {
    return [];
  }
};

export const saveUrunControlDetail = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.removeItem('UrunControlDetail');
    localStorage.setItem('UrunControlDetail', serializedState);
  } catch (error) {
    // ignore write errors
  }
};

export const saveBaslandiJob = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.removeItem('baslandiFis');
    localStorage.setItem('baslandiFis', serializedState);
  } catch (error) {
    // ignore write errors
  }
};

export const removeBaslandiJob = () => {
  localStorage.removeItem('baslandiFis');
};

// Okutulan barkod ile kul model kodu uyuşuyor mu kontrolü
export const checkValidBarkod = () => {
  let job = loadBaslandiJob()[0];
  let barkod = job.BARKOD || '';
  if ([18, 20, 22].indexOf(barkod.length) === -1) return true;
  const model_length = barkod.length === 18 ? 6 : 10;
  const txt_kul_model_kodu = barkod.substring(0, model_length);

  if (
    txt_kul_model_kodu.slice(-2) === 'RV' ||
    txt_kul_model_kodu.slice(-2) === '99'
  ) {
    // Revizyonlu ürünler
    return true;
  }
  return barkod.indexOf(job.KUL_MODEL_KODU) !== -1;
};

// Homewhiz mesajı gösterilmeli mi kontrolü
export const checkHomewhiz = hizmetKoduKontrol => {
  const job = loadBaslandiJob()[0];
  if (job === undefined) return false;
  if (parseInt(job.UST_MODEL_KODU) === 18603) {
    return false;
  }
  if (!hizmetKoduKontrol) {
    return job.HOMEWHIZ && parseInt(job.MARKA_KODU) !== 58;
  }
  let hizmet514 = false; // 514 hizmeti var mı diye kontrol ediyoruz
  job.HIZMETLER.forEach(h => {
    if (
      h.HIZMET_KODU === 235 ||
      h.HIZMET_KODU === 1772 ||
      h.HIZMET_KODU === 1887 ||
      h.HIZMET_KODU === 1894 ||
      h.HIZMET_KODU === 1896 ||
      h.HIZMET_KODU === 636
    ) {
      //buraya bakılacak
      hizmet514 = true;
    }
  });
  return hizmet514 && job.HOMEWHIZ && parseInt(job.MARKA_KODU) !== 58;
};
